import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import Modal from "./Modal";
import Switch from "./Switch";
import { color } from "../../styles/theme";

const PRIVACY_URL = "https://www.partysharingapp.com/privacy-policy-app";

const storageKey = (email) => `privacy_policy_accepted_${email || "default"}`;

export const hasAcceptedPrivacy = (email) =>
  localStorage.getItem(storageKey(email)) === "true";

const PrivacyPolicyModal = ({ onAccept, onDecline }) => {
  const { t } = useTranslation("common");
  const { user } = useAuth();
  const [agreed, setAgreed] = useState(false);

  const handleAccept = () => {
    localStorage.setItem(storageKey(user?.Email), "true");
    onAccept();
  };

  return (
    <Modal
      title={t("privacyPolicyModal.title")}
      onClose={onDecline}
      maxWidth={480}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onDecline}>{t("privacyPolicyModal.decline")}</button>
          <button type="button" className="btn btn-primary" onClick={handleAccept} disabled={!agreed}>{t("privacyPolicyModal.acceptAndContinue")}</button>
        </>
      }
    >
      <p style={s.text}>
        {t("privacyPolicyModal.introPrefix")}{" "}
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={s.link}>{t("privacyPolicyModal.privacyPolicyLink")}</a>.
      </p>
      <p style={s.subText}>
        {t("privacyPolicyModal.subText")}
      </p>

      <label style={s.checkboxLabel}>
        <Switch checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
        <span>
          {t("privacyPolicyModal.checkboxPrefix")}{" "}
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={s.link}>{t("privacyPolicyModal.privacyPolicyLink")}</a>
          {t("privacyPolicyModal.checkboxSuffix")}
        </span>
      </label>
    </Modal>
  );
};

const s = {
  text: { margin: "0 0 10px", fontSize: 13.5, color: color.gray800, lineHeight: 1.6 },
  subText: { margin: "0 0 18px", fontSize: 12.5, color: color.textSecondary, lineHeight: 1.6 },
  link: { color: color.primary600, textDecoration: "underline" },
  checkboxLabel: { display: "flex", alignItems: "center", gap: 12, fontSize: 13, color: color.gray800, cursor: "pointer", lineHeight: 1.5 },
};

export default PrivacyPolicyModal;
